import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=7195397e&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7195397e')) {
      api.createRecord('7195397e', component.options)
    } else {
      api.reload('7195397e', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=7195397e&", function () {
      api.rerender('7195397e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kscws8Wm9NqN/JS/offershelp.vue"
export default component.exports